<template>
    <div class="occupancy">
        <div class="occupancy--items">
            <div class="occupancy--adults">
                <label>Adulti</label>
                <div class="occupancy--content">
                    <span @click="remove_adult" class="square-icon">-</span>
                    <strong class="number">{{adults}}</strong>
                    <span @click="add_adult" class="square-icon">+</span>
                </div>
            </div>
            <div class="occupancy--children">
                <label>Bambini</label>
                <div class="occupancy--content">
                    <span @click="remove_child" class="square-icon">-</span>
                    <strong class="number">{{children.length}}</strong>
                    <span @click="add_child" class="square-icon">+</span>
                </div>
            </div>  
            <div class="occupancy--ages" v-if="children.length">
                <label>
                    Età dei bambini
                </label>
                <div class="occupancy--content">
                    <div v-for="(m,index) in children" v-bind:key="index">
                        <div class="occupancy--age">
                            <div><span @click="remove_child_by_index(index)" class="square-icon--small">x</span></div>
                            <div>
                                <span class="nowrap">Bambino {{index+1}}</span>
                            </div>
                            <b-form-select size="sm" :options="options" :value="m" @change="value => {set_child_age(value,index)}" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        max_children: Number,
        max_adults: Number,
        default_children: {
            type: Array,
            default: () => { return [] }
        },
        default_adults: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            adults: this.default_adults,
            children: this.default_children,
            options: [
                {value:17, text:'17 anni'},
                {value:16, text:'16 anni'},
                {value:15, text:'15 anni'},
                {value:14, text:'14 anni'},
                {value:13, text:'13 anni'},
                {value:12, text:'12 anni'},
                {value:11, text:'11 anni'},
                {value:10, text:'10 anni'},
                {value:9,  text:'9 anni'},
                {value:8,  text:'8 anni'},
                {value:7,  text:'7 anni'},
                {value:6,  text:'6 anni'},
                {value:5,  text:'5 anni'},
                {value:4,  text:'4 anni'},
                {value:3,  text:'3 anni'},
                {value:2,  text:'2 anni'},
                {value:1,  text:'1 anno'},
                {value:0,  text:'0 anni'}
            ],
        }
    },
    methods:
    {
        updated()
        {
            this.$emit( 'updated', {
                adults: this.adults,
                children: this.children,
            })
        },
        add_child() {
            if(this.children.length < this.max_children)
            {
                let children = this.children
                children.push(17)
            }
            this.updated()
        },
        remove_child(index) {
            if(this.children.length > 0)
            {
                let children = this.children
                children.splice(index, 1)
            }
            this.updated()
        },
        remove_child_by_index(index)
        {
            let children = this.children
            children.splice(index, 1)
            this.updated()
        },
        set_child_age(value,index)
        {
            let children = this.children
            children[index] = value
            this.updated()
        },
        add_adult() {
            this.adults = Math.min( this.adults+1, this.max_adults )
            this.updated()
        },
        remove_adult() {
            this.adults = Math.max( this.adults-1, 1 )
            this.updated()
        },
    },
    mounted()
    {
        this.updated() //per inviare direttamente al parent un adulto di default
    }
}
</script>

<style lang="scss">
    .occupancy
    {
        font-size: 14px;
        .custom-select
        {
            width:auto;
        }
        .nowrap
        {
            white-space: nowrap;
        }
        .number
        {
            display: inline-block;
            width: 30px;
            text-align: center;
        }
        .square-icon
        {
            display: inline-flex;
            text-align: center;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            height:28px;
            min-width:28px;
            padding:0 8px;
            color:$cta;
            box-shadow: $box-shadow;
            cursor:pointer;
            background:$white;
            height: calc(1.5em + 0.5rem + 2px);
            padding: 0.25rem 0.5rem;
            font-size: 0.75rem;
            line-height: 1.5;
            border: 1px solid #ced4da;
            box-shadow: none;
            border-radius: 6px;
            margin-top:3px;
            &--small
            {
                @extend .square-icon;
            }
        }
        &--items
        {
            display:flex;
            align-items: flex-start;
        }
        &--item
        {
            display:flex;
            flex-wrap: wrap;
            align-items: flex-start;
            padding:0 0.25rem;
        }
        &--adults
        {
            @extend .occupancy--item;
            flex:25%;
            max-width:25%;
        }
        &--children
        {
            @extend .occupancy--item;
            flex:25%;
            max-width:25%;
        }
        &--ages
        {
            min-width:50%;
            flex:50%;
            //@extend .occupancy--item;
            .occupancy--content
            {
                flex:1;
            }
            .occupancy--age
            {
                display:flex;
                align-items: center;
                //margin-bottom:10px;
                .square-icon--small
                {
                }
                .nowrap
                {
                    margin:0 10px;
                }
            }
        }
    }
</style>